import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const TogoFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16043'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16043)'>
				<rect
					width='20'
					height='14'
					fill='#FFD44D'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.57143 0H20V2.8H8.57143V0ZM8.57143 5.6H20V8.4H8.57143V5.6ZM20 11.2H0V14H20V11.2Z'
					fill='#159A74'
				/>
				<rect
					width='8.57143'
					height='8.4'
					fill='#ED1F45'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.28488 5.29202L2.60549 6.46527L3.22513 4.53747L1.56757 3.33478L3.62992 3.31658L4.28488 1.40002L4.93984 3.31658L7.00218 3.33478L5.34463 4.53747L5.96426 6.46527L4.28488 5.29202Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default TogoFlagIcon;
